module.exports = __webpack_public_path__ + "static/media/phone.0d676aa6.svg";